<div class="space-y-2">
  <label [attr.for]="id" class="block text-sm font-medium text-slate-700">
    {{ label() }}
    @if (required()) {
      <span class="text-red-500" aria-hidden="true">*</span>
    }
  </label>

  <div class="relative">
    <select
      [id]="id"
      [formControl]="control()"
      [attr.aria-invalid]="invalid()"
      class="h-11 w-full appearance-none rounded-lg border bg-white px-4 pr-10
             text-[15px] focus:outline-none focus:ring-2 focus:ring-indigo-500/30"
      [class.text-slate-400]="!control().value"
      [class.text-slate-900]="!!control().value"
      [class]="invalid()
        ? 'border-red-400 focus:border-red-500'
        : 'border-slate-200 focus:border-indigo-500'"
    >
      <option value="">{{ placeholder() }}</option>
      @for (option of options(); track option.value) {
        <option [value]="option.value" class="text-slate-900">{{ option.label }}</option>
      }
    </select>

    <svg class="pointer-events-none absolute right-3.5 top-1/2 size-4 -translate-y-1/2 text-slate-400"
         viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="m4 6 4 4 4-4" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </div>

  @if (hint() && !invalid()) {
    <p class="text-xs text-slate-500">{{ hint() }}</p>
  }
</div>
